module.exports = __webpack_public_path__ + "img/c07_unitaxeman_Normal_ua.fdf534db.webp";